<template>
  <div class="main-div">
    <v-container fluid grid-list-md :style="{ maxWidth: '1240px' }">
      <v-layout justify-space-around row wrap>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <AccountInfo></AccountInfo>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex class="xs12 md12 lg12">
          <v-card v-if="user" class="my-3 bordered-card pa-3">
            <v-card-title>
              Subscription payments
            </v-card-title>
            <v-card-text class="subscription-pay">
              <p class="bigger mb-3">
                You can extend your subscription plan by depositing ETH or BNB
                to your deposit address (one address for both).
              </p>
              <div v-if="user && user.eth_address">
                <p class="bigger pt-3" style="margin-bottom: 0px;">
                  To avoid loss of funds, strictly observe the following:
                </p>
                <v-layout row wrap class="pt-3">
                  <v-flex class="xs12 md6 lg6 pl-10 pr-10 pay-col-1">
                    <v-card class="no-shadow fill-height">
                      <v-toolbar class="toolbar-head">
                        <v-toolbar-title>
                          <span>Top-up using ETH</span>
                        </v-toolbar-title>
                      </v-toolbar>
                      <div class="fill-height">
                        <v-list class="list-body mt-1 eth-box fill-height">
                          <div>
                            <ul>
                              <li>only send <strong>ether (ETH)</strong></li>

                              <li>
                                only use the
                                <strong>Ethereum (ETH)</strong>
                                blockchain/network
                              </li>
                              <li>
                                when sending from Binance, do not use the BNB or
                                BSC options
                              </li>
                            </ul>
                          </div>
                        </v-list>
                      </div>
                    </v-card>
                  </v-flex>
                  <v-flex class="xs12 md6 lg6 pl-10 pr-10 pay-col-2">
                    <v-card class="no-shadow fill-height">
                      <v-toolbar class="toolbar-head">
                        <v-toolbar-title>
                          <span>Top-up using BNB</span>
                        </v-toolbar-title>
                      </v-toolbar>
                      <div class="fill-height">
                        <v-list class="list-body mt-1 fill-height">
                          <div>
                            <ul>
                              <li>
                                only send <strong>Binance Coin (BNB)</strong>
                              </li>
                              <li>
                                only use the
                                <strong>Binance Smart Chain (BSC)</strong>
                                blockchain/network (BEP20)
                              </li>
                              <li>
                                when sending from Binance, do not use the
                                Binance Chain (BEP2) option <br />
                              </li>
                            </ul>
                          </div>
                        </v-list>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="pt-3">
                  <v-flex class="xs12 md12 lg12 pl-10 pr-10">
                    <div style="margin-top: 8px !important">
                      <p class="deposit-address-title mb-2">
                        Your ETH and BNB deposit address:
                      </p>
                      <p class="deposit-address">
                        {{ user.eth_address.address }}
                      </p>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <p class="title-before-generate">
                  Please generate a deposit address below if you wish to do so.
                </p>
                <p>
                  <v-btn
                    class="btn-big"
                    style="margin-top: 26px;"
                    :loading="this.isAssigningEthAddress"
                    @click="assignEthAddress"
                  >
                    Generate a deposit address
                  </v-btn>
                </p>
              </div>

              <div class="payment-explanation-box">
                <div style="display: inline-block; width: 34px; float: left;">
                  <v-img
                    :src="
                      '/img/subscription_payments_icon_' + themeMode + '.svg'
                    "
                    width="20"
                    height="20"
                  />
                </div>
                <div class="left-payment-explanation-box">
                  <p class="payment-explanation">
                    We do not refund any of your deposits. Please do not send
                    more ETH or BNB than you are willing to spend on the usage
                    of the platform.
                  </p>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout justify-space-around row>
        <v-flex sm12 md12 lg12>
          <v-card class="no-border">
            <DepositsOverview />
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex class="xs12 md12 lg7 ">
          <v-card
            class="mb-3 pa-3 bordered-card"
            style="padding-bottom: 0px !important;"
          >
            <v-card-title>
              Two factor authentication
            </v-card-title>

            <v-card-text class="pl-0 pr-0 pb-2">
              <TwoFactorEnable
                v-if="!user.google_2fa_enabled"
                :skip="skipEnableStepOne"
                @updateEnableSkipSteps="onUpdateSkipSteps"
              ></TwoFactorEnable>
              <TwoFactorDisable
                v-else
                :skip="skipDisableStepOne"
                @updateDisableSkipSteps="onUpdateSkipSteps"
              ></TwoFactorDisable>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex class="xs12 md12 lg5">
          <v-card class="bordered-card reset-pass-card">
            <v-card-title>
              Reset your password
            </v-card-title>
            <v-card-text>
              <v-form ref="form" style="padding-top: 22px;">
                <v-text-field
                  v-model="old_password"
                  label="Old password"
                  name="old_password"
                  :type="type"
                  value="old_password"
                  :error-messages="formErrors.old_password"
                  style="padding-bottom: 18px;"
                >
                  <template v-slot:append>
                    <img
                      width="24"
                      height="24"
                      :src="password_icon"
                      @click="togglePassword"
                    />
                  </template>
                </v-text-field>
                <v-text-field
                  v-model="new_password"
                  label="New password"
                  name="new_password"
                  :type="type"
                  value="new_password"
                  :error-messages="formErrors.new_password"
                  style="padding-bottom: 18px;"
                >
                  <template v-slot:append>
                    <img
                      width="24"
                      height="24"
                      :src="password_icon"
                      @click="togglePassword"
                    />
                  </template>
                </v-text-field>
                <v-text-field
                  v-model="new_password_confirmation"
                  label="Confirm new password"
                  name="new_password_confirmation"
                  :type="type"
                  value="new_password_confirmation"
                  :error-messages="formErrors.new_password_confirmation"
                  style="padding-bottom: 18px;"
                >
                  <template v-slot:append>
                    <img
                      width="24"
                      height="24"
                      :src="password_icon"
                      @click="togglePassword"
                    />
                  </template>
                </v-text-field>
                <div class="text-xs-left">
                  <v-btn
                    color="primary"
                    dark
                    class="mx-0 my-3"
                    style="margin-bottom: 0 !important; margin-top: 30px !important;"
                    @click="updatePassword"
                    >Update password</v-btn
                  >
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped>
.no-shadow {
  box-shadow: none !important;
}
.bigger {
  font-size: 16px;
}
.no-border {
  box-shadow: none !important;
  background-color: inherit !important;
  border-color: inherit !important;
}
.left-payment-explanation-box {
  display: inline-block;
  width: 90%;
}
.reset-pass-card {
  padding: 16px 16px 15px;
}
.fill-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}
ul li {
  margin-top: 14px;
  font-size: 16px;
}
ul li:first-child {
  margin-top: 0px;
}
.pay-col-1 {
  padding-right: 10px !important;
}
.pay-col-2 {
  padding-left: 10px !important;
}
.fill-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.theme--light .payment-explanation {
  margin-bottom: 0px !important;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #103a84;
}
.theme--light .title-before-generate {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #7395d0;
}
.theme--light .toolbar-head {
  background: #e6efff;
  border-radius: 10px !important;
  box-shadow: none !important;
}
.theme--light .v-toolbar__title span {
  background: -webkit-linear-gradient(#468aff, #0051dd);
  background-clip: border-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}
.theme--light .list-body {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 24px 16px 24px 16px;
  color: #103a84;
}
.theme--light.application .main-div {
  background-color: #f2f7ff !important;
}
>>> .theme--light.bordered-card {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 15px;
}

>>> .theme--light .v-card__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #103a84;
}
.theme--light .subscription-pay {
  color: #103a84;
}
.theme--light .deposit-address-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #7395d0;
}
.theme--light .deposit-address {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: rgba(70, 138, 255, 1);
  word-wrap: break-word;
  margin-bottom: 0px !important;
}
.theme--light .payment-explanation-box {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 16px 24px 16px 24px;
  margin-top: 32px;
}
>>> .theme--light .v-card__text p {
  margin-bottom: 8px;
}

.theme--light >>> .v-label {
  color: #b8d2ff;
}
>>> .theme--light.v-input:not(.v-input--is-disabled) input,
>>> .theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: #103a84;
}
>>> .theme--light .v-input__slot::before {
  border-color: #b8d2ff !important;
}
>>> .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  width: 196px;
  height: 44px;
  margin: 12px 6px 8px;
  box-shadow: none !important;
}
.btn-big {
  width: 287px !important;
}
/************************************/

.theme--dark .payment-explanation {
  margin-bottom: 0px !important;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #e9e9e9;
}
.theme--dark .title-before-generate {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #e9e9e9;
}
.theme--dark .toolbar-head {
  background: #454547;
  border-radius: 10px !important;
  box-shadow: none !important;
}
.theme--dark .v-toolbar__title span {
  color: #e9e9e9;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}
.theme--dark .list-body {
  border: 1px solid #303030;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 24px 16px 24px 16px;
  color: #e9e9e9;
  background: #212121;
}
.theme--dark.v-sheet {
  background: #212121;
}
.theme--dark.v-sheet {
  background: #212121;
}

>>> .theme--dark.bordered-card {
  background: #212121;
  box-shadow: none;
  border-radius: 15px;
}

>>> .theme--dark .v-card__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #e9e9e9;
}
.theme--dark .subscription-pay {
  color: #e9e9e9;
}
.theme--dark .deposit-address-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: rgba(235, 235, 245, 0.6);
}
.theme--dark .deposit-address {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #e9e9e9;
  word-wrap: break-word;
  margin-bottom: 0px !important;
}
.theme--dark .payment-explanation-box {
  border: 1px solid #303030;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 16px 24px 16px 24px;
  margin-top: 32px;
}
>>> .theme--dark .v-card__text p {
  margin-bottom: 8px;
}
.theme--dark >>> .v-label {
  color: rgba(235, 235, 245, 0.3);
}
>>> .theme--dark.v-input:not(.v-input--is-disabled) input,
>>> .theme--dark.v-input:not(.v-input--is-disabled) textarea {
  color: #e9e9e9;
}
>>> .theme--dark .v-input__slot::before {
  border-color: rgba(235, 235, 245, 0.3) !important;
}
>>> .theme--dark .v-label.v-label--active,
>>> .theme--dark .v-input.v-input--is-focused {
  color: rgba(235, 235, 245, 0.3) !important;
  caret-color: rgba(235, 235, 245, 0.3) !important;
}

@media (max-width: 440px) {
  .left-payment-explanation-box {
    display: inline-block;
    width: 80%;
  }
}
@media (max-width: 768px) {
  .bordered-card {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}

@media (max-width: 960px) {
  .pay-col-1 {
    padding-right: 4px !important;
  }
  .pay-col-2 {
    padding-left: 4px !important;
  }
}

</style>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import swal from "sweetalert2";
import TwoFactorEnable from "~/components/settings/TwoFactorEnable";
import TwoFactorDisable from "~/components/settings/TwoFactorDisable";
import DepositsOverview from "../../components/settings/DepositsOverview";
import AccountInfo from "../../components/insights/settings/AccountInfo";

export default {
  components: {
    DepositsOverview,
    TwoFactorEnable,
    TwoFactorDisable,
    AccountInfo
  },
  loading: false,
  metaInfo() {
    return {
      title: "Settings"
    };
  },
  data() {
    return {
      isAssigningEthAddress: false,
      old_password: null,
      new_password: null,
      new_password_confirmation: null,
      loading: false,
      type: "password",
      formErrors: {},
      skipEnableStepOne: false,
      skipDisableStepOne: false
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      darkmode: "settings/darkmode"
    }),
    themeMode: function() {
      return this.darkmode ? "dark" : "light";
    },
    password_icon: function() {
      return this.type === "password"
        ? "/img/eye-icon-" + this.themeMode + ".svg"
        : "/img/eye-open-icon-" + this.themeMode + ".svg";
    }
  },
  created: function() {
    const apiDetails = _.find(this.user.api_keys, function(apiKey) {
      return apiKey.pivot.exchange_name.toLowerCase() === "bittrex";
    });

    if (apiDetails) {
      this.api_form.api_key = apiDetails.pivot.api_key;
      this.api_form.api_secret = apiDetails.pivot.api_secret;
    }

    this.$store.dispatch("auth/fetchUser");
  },
  methods: {
    onUpdateSkipSteps: function(data) {
      if (data.hasOwnProperty("skipEnableStepOne")) {
        this.skipDisableStepOne = data.skipEnableStepOne;
      } else if (data.hasOwnProperty("skipDisableStepOne")) {
        this.skipEnableStepOne = data.skipDisableStepOne;
      }
    },
    updatePassword: async function() {
      // do api call
      const { data } = await axios
        .put("/api/v1/settings/password", {
          old_password: this.old_password,
          new_password: this.new_password,
          new_password_confirmation: this.new_password_confirmation
        })
        .then(response => {
          if (response.status === 200) {
            swal({
              title: "Password updated",
              text: data,
              showCloseButton: true,
              customClass: "swal-type-warning",
              imageUrl: "/img/popup_img_warning.png",
              imageHeight: 48,
              imageWidth: 48
            });

            this.old_password = null;
            this.new_password = null;
            this.new_password_confirmation = null;

            this.password = null;
          }
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.formErrors = error.response.data.errors;
          }
          return false;
        });
    },
    assignEthAddress: async function() {
      this.isAssigningEthAddress = true;
      try {
        const wallet = await axios.get("/api/v1/settings/assign-eth-address");

        this.user.eth_address = wallet.data;
        this.isAssigningEthAddress = false;
      } catch (error) {
        swal({
          title: error.response.data,
          showConfirmButton: false,
          showCloseButton: true,
          customClass: this.darkmode ? "swal-type-error-dark" : "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });

        this.isAssigningEthAddress = false;
        return false;
      }
    },
    togglePassword() {
      this.type = this.type === "password" ? "text" : "password";
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/insights/settings.vue